<template>
    <common-modal
        height="medium"
        width="extra-large"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <div class="content">
            <div v-if="providers[0]?.practice?.practiceType === PracticeTypeEnum.PHYSICIAN" class="providers-list">
                <div v-for="(item, index) in providers" :key="itemKey(item, index)" class="providers-list__item">
                    <external-recipient-card v-if="item.type === 'external'" :recipient="item"></external-recipient-card>
                    <practice-member-card
                        v-else
                        :physician="item"
                        :showNetworkInclusionStatus="false"
                        :showMasterUserAuthorities="false"
                        :showCardAvailability="false"
                    ></practice-member-card>
                </div>
            </div>
            <div v-else class="providers-list">
                <ancillary-member-card
                    v-for="item in providers"
                    :key="item.id"
                    :ancillary="item"
                    :showCardAvailability="false"
                ></ancillary-member-card>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'
    import ExternalRecipientCard from 'components/page-elements/practice/ExternalRecipientCard'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            PracticeMemberCard,
            AncillaryMemberCard,
            ExternalRecipientCard,
        },
        props: {
            referralPoolId: { type: Number, required: true },
        },
        data() {
            return {
                providers: [],
                PracticeTypeEnum,
            }
        },

        methods: {
            itemKey(item, index) {
                if (item.type === 'external') return `ext-${item.providerNpi || item.id || index}`
                return item.id != null ? item.id : `in-pool-${index}`
            },
            getReferralPoolProviders() {
                ReferralsPoolAPI.getReferralsPoolProviders(this.referralPoolId, {
                    feasibility: this.$auth.isUserAdministrator(),
                }).then((response) => {
                    this.providers = response
                })
            },
        },

        mounted() {
            this.getReferralPoolProviders()
        },
    }
</script>

<style scoped lang="scss">
    .content {
        max-height: 500px;
        overflow-y: auto;
    }

    .providers-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px 10px;
        overflow-x: hidden;

        &__item {
            min-width: 0;
        }
    }
</style>
